import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const FaqsApi = createApi({
    reducerPath: "faqs",
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getAllFaqs: builder.query({
            query: () => ({
                url: `api/admin/faq`,
                method: "GET",
                transformResponse: (res) => res.data,
            }),
        }),

        addNewFaq: builder.mutation({
            query: (newFaq) => (
                {
                    url: `api/admin/faq`,
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: newFaq,
                }),
        }),

        updateFaq: builder.mutation({
            query: (updatedFaq) => ({
                url: `api/admin/faq`,
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: updatedFaq
            }),
        }),
    }),
});

export const { useGetAllFaqsQuery, useAddNewFaqMutation, useUpdateFaqMutation } = FaqsApi;